export enum BibliographicResourceType {
  Article = 'Article',
  AudioDocument = 'AudioDocument',
  AudioVisualDocument = 'AudioVisualDocument',
  Book = 'Book',
  Chapter = 'Chapter',
  Document = 'Document',
  Image = 'Image',
  Journal = 'Journal',
  LegalCaseDocument = 'LegalCaseDocument',
  LegalDocument = 'LegalDocument',
  Legislation = 'Legislation',
  Score = 'Score',
  Page = 'Page',
  Presentation = 'Presentation',
  Proceedings = 'Proceedings',
  Thesis = 'Thesis',
  Video = 'Video',
  Webpage = 'Webpage',
  Website = 'Website',
}

export const ALL_BIBLIOGRAPHIC_RESOURCE_TYPES: BibliographicResourceType[] =
  Object.keys(BibliographicResourceType).map(
    key => BibliographicResourceType[key],
  );
